module.exports = __webpack_public_path__ + "img/team.027c7f01.jpg";